module.exports = __webpack_public_path__ + "img/img_customer_initiator.af4a3dd8.svg";